import React from 'react'
import './styles.css'

/*const defaultConfig = {
	type: "text",
	placeholder: "",
	name: "input",
	label: ""
};
const newProps = { ...defaultConfig, ...props };
*/

class NuDrop extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      //item es controlado desde afuera
      //itemSelected :{"value":"","label":""}, //itemSelected":{"value":"","label":"Completo"}
    };

    //------------ para el click outside
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  //======================= clic outside ==========================
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  
  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      //alert("You clicked outside of me!");
      //console.log("You clicked outside of me!")
      if(this.state.open===true){
        this.setState({open: false })
      }
    }
  }
  //=================================================
  toggleDropDown = () => {
    console.log( this.state.open)
    this.setState({ open: !this.state.open });
  };
  //-----------------------------------------------
  clickItem = (e, item) => {
    e.preventDefault();
    // 👇️ filter with 1 condition
    //console.log(e.target.value);
    console.log(item)

    this.toggleDropDown()
    this.props.onClickItem(item);
    
  }
  //-------------------------------------
  buscarItem=(value)=>{

    const filtered = this.props.options.filter(item => {
      return item.value == value;
    });
    //console.log(filtered[0]); //sino hay retorna undefined
    //---lo anexamos para ser retornado
    let miItem={value:'', label:''};
    if(miItem!==null){
      miItem = filtered[0]
    }
    return miItem
  }
  //-----------------------------------------------
  render() {
    let itemSelected =  this.buscarItem(this.props.value)
    return (

      <div className="dropdownj" ref={this.wrapperRef} > 
        {
          //JSON.stringify(this.state )
        }
        {
          itemSelected.label
        }

        <button className={` ${this.props.classBtn} ` } 
                onClick={ this.toggleDropDown } 
                style={ this.props.styleBtn }
                >
          {/* mostramos texto o icono */}
          {(this.props.iconBtn!=="") &&
              <i className={ this.props.iconBtn}></i>
          }
          { this.props.text }
          
        </button>

      
        <div className="">
          <div 
            className="dropdownj-content"
            tabIndex="0"       
          >
            
            {this.state.open ? (
              <div className="menu" style={{ display: `${this.state.open ? 'block' : 'none'}`}} >
                {
                this.props.options.map((item, index) => (
                  <div  className="item" key={index} 
                        onClick={(e)=> this.clickItem(e, item) }>
                    <i className="edit icon" /> {item.label}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
        
      </div>
    );
  }
}


export default NuDrop;

// Set default props
NuDrop.defaultProps = {
  /* Declare your default Props here */
  classBtn:'btn1 btn-14',
  options:[],
  iconBtn:"",
  styleBtn:{},
  text:'...',
  value:'',
};

/**
 *  <div className="item">
                  <i className="edit icon" /> Edit Post
                </div>
                <div className="item">
                  <i className="delete icon" /> Remove Post
                </div>
                <div className="item">
                  <i className="hide icon" /> Hide Post
                </div>
 * 
 */